import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { RowSeparator } from "./RowSeparator";
/**
 * Represents a Row separator, this is used to visually separate the rows in a grid
*/
var IgrRowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrRowSeparator, _super);
    function IgrRowSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrRowSeparator.prototype.createImplementation = function () {
        return new RowSeparator();
    };
    Object.defineProperty(IgrRowSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrRowSeparator;
}(IgrDefinitionBase));
export { IgrRowSeparator };
//# sourceMappingURL=igr-row-separator.js.map
